<template>
  <div>
    <v-card outlined class="mb-6">
      <v-toolbar flat>
        <v-toolbar-title>{{ $t('message.payment_method') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text class="py-0">
        {{ $t('message.fixed_term_payment_paragraph_2') }}
      </v-card-text>

      <v-row v-if="updateLoading" no-gutters justify="center" class="py-12">
        <v-progress-circular color="primary" indeterminate></v-progress-circular>
      </v-row>
      <template v-else-if="agreement.stripeSource">
        <v-list two-line>
          <v-list-item>
            <v-list-item-avatar>
              <v-img
                :src="
                  require('@/assets/img/payment_methods/' +
                    agreement.stripeSource.card.brand.toLowerCase().replace(/ /g, '-') +
                    '.svg')
                "
                alt="Credit Card Icons"
              />
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title>
                {{ getCardLabel(agreement.stripeSource.card) }}
                <span v-if="agreement.stripeSource.billing_details.name" class="grey--text text--darken-2"
                  >({{ agreement.stripeSource.billing_details.name }})</span
                >
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $t('message.expires_in') }}

                {{ $moment.months(agreement.stripeSource.card.exp_month - 1) }}
                <template v-if="'es' === $i18n.locale">de</template>
                {{ agreement.stripeSource.card.exp_year }}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
        <v-card-actions>
          <v-btn text color="primary" @click="selectorShow = true">{{ $t('message.change_or_add_card') }}</v-btn>
        </v-card-actions>
      </template>
      <v-card-text v-else>
        <v-btn depressed color="primary" @click="selectorShow = true">{{ $t('message.add_card') }}</v-btn>
      </v-card-text>
    </v-card>

    <v-dialog v-model="selectorShow" width="500">
      <v-card>
        <PaymentMethodSelector class="mb-6" :agreement="agreement" @change="newPaymentMethod = $event" />
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" depressed @click="selectorShow = false">{{ $t('message.cancel') }}</v-btn>
          <v-btn
            :disabled="!newPaymentMethod"
            color="primary"
            depressed
            @click="updatePaymentMethod(newPaymentMethod)"
            >{{ $t('message.use_this_card') }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="updateError" :timeout="2000">
      {{ $t('message.error_updating_payment_method') }}

      <template v-slot:action="{ attrs }">
        <v-btn color="primary" text v-bind="attrs" @click="updateError = false">
          {{ $t('message.close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import PaymentMethodSelector from '@/components/ActivationCreateDialog/PaymentMethodSelector'
import fetch from '@/utils/fetch'

export default {
  name: 'PaymentMethod',
  components: { PaymentMethodSelector },
  props: {
    agreement: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectorShow: false,
      newPaymentMethod: null,
      updateLoading: false,
      updateError: false
    }
  },
  methods: {
    getCardLabel(card) {
      return this.$t('message.payment_methods.brand.' + card.brand) + ' •••• ' + card.last4
    },

    updatePaymentMethod(paymentMethod) {
      if (this.agreement.stripeSource && this.newPaymentMethod.id === this.agreement.stripeSource.id) {
        this.selectorShow = false
        return
      }
      this.selectorShow = false
      this.updateLoading = true
      fetch(this.agreement['@id'], {
        method: 'PUT',
        headers: new Headers({ 'Content-Type': 'application/ld+json' }),
        body: JSON.stringify({ stripeSourceId: paymentMethod.id })
      })
        .then(response => response.json())
        .then(() => {
          this.$emit('reload')
        })
        .catch(() => {
          this.updateError = true
        })
        .then(() => {
          this.updateLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
